import { Button, Grid, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Delete, MoreVert } from '@material-ui/icons';
import EditIcon from '../../assets/SvgIonReorderTwo';
import { formateDate, sortItemsBySelection } from '../utils/Utils';
import Image from './Image';
import Lock from '../../assets/Lock';

const useStyle = makeStyles({
  journeyCard: {
    background: '#f3f4f7',
    padding: '10px',
    width: '95%',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  journeyWrapper: {
    display: 'flex',
    gap: '10px',
    width: '95%',
  },
  journeyImg: {
    height: '80px',
    width: '55px',
  },
  jouneyContent: {
    width: '100%',
  },
  jouneyTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  journeyDate: {
    fontSize: '12px',
  },
  equlaIcon: {
    fontSize: '18px',
  },
  journesContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '10px',
  },
  journesWrapper: {
    width: '100%',
    height: '550px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  newJourneyCard: {
    background: '#f3f4f7',
    padding: '10px',
    width: '97%',
    borderRadius: '10px',
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  addNewJourney: {
    display: 'flex',
    gap: '10px',
    width: '95%',
  },
  searchBox: {
    width: '100%',
  },
  searchField: {
    width: '96%',
    padding: '10px',
  },
  actionBtns: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'flex-end',
  },
  cancelBtn: {
    border: '1px solid gray',
    cursor: 'pointer',
    height: '40px',
    width: '80px',
    borderRadius: '4px',
  },
  addBtn: {
    cursor: 'pointer',
    height: '40px',
    width: '75px',
    borderRadius: '4px',
  },
  checkbox: {
    width: '18px',
    height: '18px',
  },
  lockIconContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});

export default function JourneyCard({ journeyData, setAnchorEl, setSelectedId, showLock = false }) {
  const classes = useStyle();

  const handleClick = (event, JourneyId) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(JourneyId);
  };

  return (
    <div className={classes.journeyCard}>
      <p className={classes.equlaIcon}>
        <EditIcon />
      </p>
      <Grid className={classes.journeyWrapper}>
        <Image className={classes.journeyImg} src={journeyData.thumbnail} alt="Journey Pic" />
        <Grid className={classes.jouneyContent}>
          <Grid className={classes.jouneyTitle}>
            <Typography>{journeyData.title}</Typography>
            <div className={showLock ? classes.lockIconContainer : ''}>
              {showLock && <Lock />}
              <MoreVert onClick={(e) => handleClick(e, journeyData.id)} style={{ cursor: 'pointer' }} />
            </div>
          </Grid>
          <Typography variant="body2" className={classes.journeyDate}>
            {`ID: ${journeyData.id}`}
          </Typography>
          <Typography variant="p" className={classes.journeyDate}>
            {formateDate(journeyData.publishDate)}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export function MenuItems({ anchorEl, setAnchorEl, onDelete }) {
  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem style={{ justifyContent: 'left' }} onClick={onDelete}>
        <Delete /> Remove Journey
      </MenuItem>
    </Menu>
  );
}

export function AllJourneysList({
  handleSelectJourney,
  selectedJourneys,
  setSelectedJourneys,
  handleUpdateJourney,
  setIsOpenModal,
  filteredJourneys,
  setFilteredJourneys,
  journeys,
}) {
  const classes = useStyle();
  const [searchValue, setSearchValue] = useState('');
  const [temp] = useState(selectedJourneys);

  // Selected list should move up in the list
  const sortedJourneys = sortItemsBySelection(selectedJourneys, filteredJourneys, 'id');

  useEffect(() => {
    if (searchValue) {
      const filtered = journeys.filter((journey) => journey.title.toLowerCase().includes(searchValue.toLowerCase()));
      setFilteredJourneys(filtered);
    } else {
      setFilteredJourneys(journeys);
    }
  }, [searchValue, journeys]);

  return (
    <Grid container className={classes.journesContainer}>
      <Grid>
        <Typography>Add New Journeys</Typography>
      </Grid>
      <Grid className={classes.searchBox}>
        <input
          className={classes.searchField}
          type="text"
          placeholder="Search Journey"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </Grid>
      <Grid className={classes.journesWrapper}>
        {sortedJourneys?.map((data) => (
          <Grid className={classes.newJourneyCard} key={data.id}>
            <p className={classes.equlaIcon}>
              <input
                type="checkbox"
                onChange={() => handleSelectJourney(data.id)}
                checked={selectedJourneys.includes(data.id)}
                className={classes.checkbox}
              />
            </p>
            <Grid className={classes.addNewJourney}>
              <Image className={classes.journeyImg} src={data.thumbnail} alt="Journey Pic" />
              <Grid className={classes.jouneyContent}>
                <Grid className={classes.jouneyTitle}>
                  <Typography> {data.title} </Typography>
                </Grid>
                <Typography variant="p" className={classes.journeyDate}>
                  {formateDate(data?.publishDate)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid className={classes.actionBtns}>
        <Button
          onClick={() => {
            setSelectedJourneys(temp);
            setIsOpenModal(false);
          }}
          className={classes.cancelBtn}
        >
          Cancel
        </Button>
        <Button
          className={classes.addBtn}
          color="primary"
          variant="contained"
          onClick={() => handleUpdateJourney(selectedJourneys)}
        >
          Add
        </Button>
      </Grid>
    </Grid>
  );
}
